import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, {
        class: "main-background release-page-shell",
        fullscreen: true,
        slot: "fixed",
        "scroll-y": false
      }, {
        default: _withCtx(() => [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "release-safe-area" }, null, -1)),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "release-chrome-circle release-chrome-circle--start top-level",
            "aria-label": "Закрыть",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.returnBack()))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.closeOutline }, null, 8, ["icon"])
          ], 512), [
            [_vShow, !_ctx.isLandscapeMode && !_ctx.isReleaseMusic]
          ]),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "release-chrome-circle release-chrome-circle--start top-level",
            "aria-label": "Назад",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.returnBack('Programs')))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.chevronDown }, null, 8, ["icon"])
          ], 512), [
            [_vShow, _ctx.isLandscapeMode && _ctx.isMobile]
          ]),
          _withDirectives(_createElementVNode("button", {
            type: "button",
            class: "release-chrome-circle release-chrome-circle--end top-level",
            "aria-label": "Полный экран",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFullscreenMode(true)))
          }, [
            _createVNode(_component_ion_icon, { icon: _ctx.resize }, null, 8, ["icon"])
          ], 512), [
            [_vShow, _ctx.isReleaseVideo && !_ctx.isLandscapeMode && _ctx.isMobile]
          ]),
          _createVNode(_component_ion_router_outlet, { id: "release-router" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}